import { Loader2, Tag, X } from 'lucide-react';

const RetailDiscountCode = ({
  appliedDiscount,
  currencySymbol = '',
  discountAmount = 0,
  discountCode = '',
  error = '',
  isApplying = false,
  isDisabled = false,
  onApply,
  onChange,
  onRemove
}) => {
  const appliedCode = appliedDiscount?.code || discountCode;

  return (
    <div className="mb-4 rounded-lg border border-dashed border-emerald-300 bg-emerald-50/60 p-3">
      <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-gray-900">
        <Tag size={16} className="text-emerald-700" />
        Have a discount code?
      </div>

      {appliedDiscount ? (
        <div>
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="truncate font-mono text-sm font-bold text-emerald-800">{appliedCode}</p>
              <p className="text-xs text-emerald-700">
                You save {currencySymbol}{Number(discountAmount || 0).toFixed(2)}
              </p>
            </div>
            <button
              type="button"
              className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-semibold text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
              disabled={isDisabled}
              onClick={onRemove}
            >
              <X size={14} />
              Remove
            </button>
          </div>
        </div>
      ) : (
        <div className="flex gap-2">
          <input
            type="text"
            value={discountCode}
            onChange={(event) => onChange?.(event.target.value.toUpperCase())}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                onApply?.();
              }
            }}
            placeholder="Enter discount code"
            disabled={isApplying || isDisabled}
            className="min-w-0 flex-1 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm uppercase outline-none transition focus:border-emerald-600 focus:ring-2 focus:ring-emerald-100 disabled:cursor-not-allowed disabled:bg-gray-100"
          />
          <button
            type="button"
            onClick={onApply}
            disabled={isApplying || isDisabled || !discountCode.trim()}
            className="inline-flex min-w-20 items-center justify-center rounded-md bg-emerald-700 px-3 py-2 text-sm font-semibold text-white transition hover:bg-emerald-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isApplying ? <Loader2 size={16} className="animate-spin" /> : 'Apply'}
          </button>
        </div>
      )}

      {error && <p className="mt-2 text-xs font-medium text-red-600">{error}</p>}
    </div>
  );
};

export default RetailDiscountCode;
